import React from "react";
import { View, StyleSheet } from "react-native";
import { Colors } from "styled42/config";
import SText from "styled42/components/SText";
import SClickableArea from "styled42/components/SClickableArea";

const OvalComponent = ({
  text,
  style,
  containerStyle = {},
  ovalContainerStyle = {},
  onClick,
  selected,
  ...props
}) => (
  <SClickableArea onClick={onClick} style={containerStyle}>
    <View
      style={[
        styles.ovalContainer,
        ovalContainerStyle,
        selected ? styles.selectedOvalContainer : null
      ]}
    >
      <SText
        style={[
          styles.ovalComponentText,
          selected ? styles.selectedOvalComponentText : null,
          style
        ]}
        {...props}
      >
        {text}
      </SText>
    </View>
  </SClickableArea>
);

const styles = StyleSheet.create({
  ovalContainer: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 4,
    paddingHorizontal: 16,
    borderRadius: 14,
    marginRight: 8,
    marginVertical: 6,
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: "#DBDBDB",
    backgroundColor: "#FFFFFF"
  },
  selectedOvalContainer: {
    backgroundColor: "#FFF3E8",
    borderColor: "#FF9518"
  },
  ovalComponentText: {
    color: "#676574"
  },
  selectedOvalComponentText: {
    color: "#000000",
    fontWeight: "bold"
  }
});

export default OvalComponent;
